import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"height":"12rem"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_3 = { key: 0 }

import { computed } from 'vue';
import { v4 as uuidv4 } from 'uuid';
import { gradeToDescription } from '@/utils/utilsHandle';

// component
import Level from './Level.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Array as () => Array<any>,
    default: [],
  },
},
  setup(__props) {

const props = __props


const multiple100 = (num: number | null | undefined) => {
  if (typeof num === 'number') return num * 100 + '%';
  return num;
};
const extendedData = computed(() =>
  props.data
    .map((it) =>
      [{ name: it.name, type: 'head', id: uuidv4() }].concat(
        it.kriMetricsList || []
      )
    )
    .reduce((prev, cur: any) => prev.concat(...cur), [])
);

const tableRowClassName = ({ row }: { row: any; rowIndex: number }) => {
  if (row.type === 'head') {
    return 'table-head';
  } else {
    return 'table-body';
  }
};

return (_ctx: any,_cache: any) => {
  const _component_simple_table_column = _resolveComponent("simple-table-column")!
  const _component_Top = _resolveComponent("Top")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Bottom = _resolveComponent("Bottom")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      class: "fotile-table",
      data: _unref(extendedData),
      "row-key": "id",
      height: "100%",
      style: {"background-color":"transparent","--border-color":"transparent"},
      "row-class-name": tableRowClassName
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_simple_table_column, {
          label: "指标",
          prop: "name"
        }),
        _createVNode(_component_simple_table_column, {
          label: "值",
          prop: "displayKriValue"
        }),
        _createVNode(_component_simple_table_column, {
          label: "定级",
          prop: "kriLevel"
        }, {
          default: _withCtx(({ row }) => [
            (row.type !== 'head')
              ? (_openBlock(), _createBlock(Level, {
                  key: 0,
                  level: row.kriLevel
                }, null, 8, ["level"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_simple_table_column, {
          label: "同比",
          prop: "trendLevel"
        }, {
          default: _withCtx(({ row }) => [
            (row.type !== 'head')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["year-on-year icon", { red: row.trendLevel < 0 }])
                }, [
                  (row.trendLevel < 0)
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Top)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (row.trendLevel > 0)
                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Bottom)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_simple_table_column, {
          label: "权重",
          prop: "weight"
        }, {
          default: _withCtx(({ row }) => [
            (row.type !== 'head')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(multiple100(row.weight)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})